import { AccessibilityButton } from '@/components/shared/headers/Header/AccessibilityButton';
import { MenuButton } from '@/components/shared/headers/Header/MenuButton';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { HeaderMenu } from '@/components/shared/headers/Header/HeaderMenu';
import HeaderStore from '@/domain/core/HeaderStore';
import User from '@/domain/core/User';

import { HeaderLogo } from './HeaderLogo';
import { LanguageSwitcher } from './LanguageSwitcher';
import { LogoutButton } from './LogoutButton';
import { NotificationButton } from './NotificationButton';
import { UserProfile } from './UserProfile';

const Header = observer(() => {
	const HeaderStoreInstance = React.useMemo(() => new HeaderStore(User), []);
	const { tabsConfig } = HeaderStoreInstance;

	return (
		<>
			<section className="min-[800px]:block hidden">
				<header className="flex items-center h-25 pl-8 pr-5 gap-6">
					<div className="grid items-center gap-4 shrink-0">
						<HeaderLogo href="/" />
					</div>

					<HeaderMenu menuItems={tabsConfig} orientation="horizontal" />

					<div className="ml-auto grid items-center grid-cols-[repeat(5,auto)] gap-4 shrink-0">
						<AccessibilityButton />
						<LanguageSwitcher />
						<NotificationButton />
						<UserProfile hasInfo={true} />
						<LogoutButton />
					</div>
				</header>
			</section>

			<section className="max-[799px]:block min-[800px]:hidden">
				<header className="grid grid-cols-[1fr_auto] items-center pr-4 pl-0 gap-4">
					<div className="grid grid-rows-[auto_auto] items-center">
						<HeaderLogo href="/" />
					</div>

					<div className="grid items-center justify-end grid-cols-[repeat(4,auto)] gap-4">
						<AccessibilityButton />
						<NotificationButton />
						<UserProfile hasInfo={false} />
						<MenuButton hasActions={true}/>
					</div>
				</header>
			</section>
		</>
	);
});

export {Header};
